import { defineMessages } from 'react-intl';

export default defineMessages({
  allocationLabel: {
    id: 'allocation',
    description: 'allocation label',
    defaultMessage: 'allocation',
  },
});
